import { cn } from '@/lib/utils';

import { type ShellTheme } from './shell-theme.constants';

export const ShellThemeSwatch = ({
  preset,
  className,
}: {
  preset: ShellTheme;
  className?: string;
}) => (
  <span
    data-shell-theme={preset}
    className={cn(
      'shell-wash shell-swatch block rounded-full border border-border-strong',
      className
    )}
  />
);
